<template>
	<div class="d-flex align-center">
		<img
			v-if="image"
			:src="image"
			class="mr-2 cover"
		/>
		<div
			v-if="Object.keys(geoShape).length"
			class="mr-4 ao-preview-related-image"
		>
			<GeometryPictogram
				:feature="geoShape"
				class="geometry-pictogram-svg"
			/>
		</div>
		<div
			v-if="icon"
			class="mr-4 ao-preview-related-image"
		>
			<ao-icon
				class="mr-1 text-textSecondary700"
				:iconName="icon"
				size="large"
			/>
		</div>
		<div>
			<div class="ao-p2-medium d-flex align-center">
				<span>{{ title }}</span>
				<slot name="popupInfo"/>
			</div>
			<div class="ao-p4-medium ao-text-secondary-color-700">
				<slot>{{ subtitle }}</slot>
			</div>
		</div>
	</div>
</template>

<script setup>
import GeometryPictogram from '@/components/ui/GeometryPictogram.vue'

const props = defineProps({
		image: {
			type: String,
			default: '',
		},
		icon: {
			type: String,
			default: '',
		},
		geoShape: {
			type: Object,
			default: () => ({})
		},
		title: {
			type: String,
			default: '',
		},
		subtitle: {
			type: String,
			default: '',
		},
})
</script>

<style scoped lang="scss">
.cover {
	width: 32px;
	height: 32px;
}

.close_btn {
	z-index: 1;
	position: absolute;
	top: 0;
	right: 0;
}
.geometry-pictogram-svg {
  min-height: 24px;
  max-height: 24px;
  min-width: 24px;
  max-width: 24px;

  & > svg {
   width: 100%;
   max-height: 100%;
  }
 }
 .ao-preview-related-image{
	max-width: 32px;
	max-height: 32px;
	width:100%;
}
</style>
